import { CheckTextSelect, FormClassRetire } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の送付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "送付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: (ITkFakeTableLineProps & { docsKind?: string[] })[] = [
  {
    title: "確認する書類の選択",
    keyword: "identifyDocsKind",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CheckTextSelect),
    requiredIcon: true,
  },
  {
    title: "本人であることが確認できる書類",
    keyword: "identityDocs1",
    type: "fileUpload",
    helpicon: true,
    requiredIcon: true,
    helpText:
      "次の①～⑤のいずれかの書類の写しを添付してください。①個人番号カード（顔写真のある面）、②運転免許証（表裏）、③運転経歴証明書、④パスポート、⑤健康保険証、年金手帳、公共料金の領収書の中から２種類",
    showLine: false,
    docsKind: [
      CheckTextSelect["個人番号カード（１２桁の番号のある面）"],
      CheckTextSelect["個人番号が記載された住民票＋写真無し身分証明２点"],
      CheckTextSelect["通知カード＋写真無し身分証明２点"],
    ],
    id: FormClassRetire["本人確認書類"],
  },
  {
    title: "本人であることが確認できる書類",
    keyword: "identityDocs2",
    type: "fileUpload",
    helpicon: true,
    requiredIcon: true,
    helpText:
      "次の①～⑤のいずれかの書類の写しを添付してください。①個人番号カード（顔写真のある面）、②運転免許証（表裏）、③運転経歴証明書、④パスポート、⑤健康保険証、年金手帳、公共料金の領収書の中から２種類",
    showLine: false,
    docsKind: [
      CheckTextSelect["個人番号が記載された住民票＋写真無し身分証明２点"],
      CheckTextSelect["通知カード＋写真無し身分証明２点"],
    ],
    id: FormClassRetire["本人確認書類"] + 2,
  },
  {
    title: "本人であることを確認するための書類（表）",
    keyword: "identityDocHead",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    docsKind: [
      CheckTextSelect["個人番号が記載された住民票＋写真付き身分証明１点"],
      CheckTextSelect["通知カード＋写真付き身分証明１点"],
    ],
    id: FormClassRetire["本人確認書類（表面）"],
  },
  {
    title: "本人であることを確認するための書類（裏）",
    keyword: "identityDocTail",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    docsKind: [
      CheckTextSelect["個人番号が記載された住民票＋写真付き身分証明１点"],
      CheckTextSelect["通知カード＋写真付き身分証明１点"],
    ],
    id: FormClassRetire["本人確認書類（裏面）"],
  },
  {
    title: "死亡した退職者の個人番号を確認する書類",
    keyword: "deceasedRetireeNumCheckDoc",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    id: FormClassRetire["死亡した退職者の個人番号を確認する書類"],
  },
  {
    title: "個人番号を確認する書類",
    keyword: "numberCheckDoc",
    type: "fileUpload",
    helpicon: true,
    requiredIcon: true,
    requiredText: "法律で定められた義務",
    helpText:
      "次のいずれか１つを選んでください。①個人番号カード（個人番号がある面）、②番号通知カード（表示されている氏名、住所に変更がない場合のみ有効です）、③個人番号が記載された住民票",
    showLine: false,
    id: FormClassRetire["個人番号を確認する書類"],
  },
  {
    title: "振込先口座が確認できる書類",
    keyword: "payAccountCheckDoc",
    type: "fileUpload",
    helpicon: true,
    requiredIcon: true,
    helpText:
      "次の①～③のいずれかの書類の写しを添付してください。①通帳の「表紙」と「見開きページ」、②キャッシュカードの写し（金融機関名、支店番号、口座番号、口座名義のある面）※クレジットカード機能付きの場合は、クレジットカードの番号を伏せて登録してください。、③インターネットバンキングなど通帳がない場合は、WEB上の口座情報が確認できるページなど、振込先口座が確認できるもの",
    showLine: false,
    id: FormClassRetire["振込先口座が確認できる書類"],
  },
];

const required = { required: TkPropertyMessageGet("TKMSG_SCR0044E") };
const schema = {
  identifyDocsKind: required,
  payAccountCheckDoc: required,
};

export { stepper, fakeTableList, schema, required };
